
export const pricingPlans = [
  {
    id: 1,
    name: 'Базовый',
    description: 'Для простого ремонта',
    price: '8 000',
    priceNote: 'от',
    icon: 'ri-tools-line',
    popular: false,
    features: [
      'Диагностика неисправностей',
      'Мелкий ремонт',
      'Консультация мастера',
      'Гарантия 3 месяца',
      'Выезд в день обращения'
    ]
  },
  {
    id: 2,
    name: 'Стандарт',
    description: 'Оптимальное решение',
    price: '15 000',
    priceNote: 'от',
    icon: 'ri-star-line',
    popular: true,
    features: [
      'Полная диагностика',
      'Замена основных деталей',
      'Профилактика техники',
      'Гарантия 6 месяцев',
      'Срочный выезд (1-2 часа)',
      'Скидка 10% на запчасти'
    ]
  },
  {
    id: 3,
    name: 'Премиум',
    description: 'Комплексное обслуживание',
    price: '25 000',
    priceNote: 'от',
    icon: 'ri-vip-crown-line',
    popular: false,
    features: [
      'Комплексная диагностика',
      'Замена любых деталей',
      'Полная профилактика',
      'Гарантия 12 месяцев',
      'Выезд в течение часа',
      'Скидка 20% на запчасти',
      'Бесплатное ТО через 6 месяцев'
    ]
  }
];
